import checkout from "./form";

const {
  formField: {
    address,
    certificate,
    email,
    fax,
    fullName,
    firstTime,
    phone,
    signer,
    supplementaryForThe,
    taxAgencyId,
    taxAgencyName,
    taxCalculationPeriod,
    taxId,
    taxpayerName,
    timeSign,
  },
} = checkout;

const initialValues = {
  [address.name]: "",
  [certificate.name]: "",
  [email.name]: "",
  [fax.name]: "",
  [fullName.name]: "",
  [firstTime.name]: false,
  [phone.name]: "",
  [signer.name]: "",
  [supplementaryForThe.name]: "",
  [taxAgencyId.name]: "",
  [taxAgencyName.name]: "",
  [taxCalculationPeriod.name]: "",
  [taxId.name]: "",
  [taxpayerName.name]: "",
  [timeSign.name]: "",
};

export default initialValues;
